import { AdvancedAutocomplete } from 'civic-champs-shared'
import { FieldProps, getIn } from 'formik'
import { filter } from 'lodash'
import React from 'react'
import { Role } from 'volunteer-role/types'
import { EventDateScreenValues } from './EventDateAndRoleScreen'

interface RoleAutocompleteFieldProps extends FieldProps<Number, EventDateScreenValues> {
  roles: Role[]
  addRole?: () => Promise<Role>
}
export const RoleAutocompleteField = ({ field, form, roles, addRole, ...props }: RoleAutocompleteFieldProps) => {
  const { values, setFieldValue } = form
  const touched = getIn(form.touched, field.name)
  const error = getIn(form.errors, field.name)

  const selectedRoles = new Set([...values.roles.map(({ roleId }) => roleId)])

  return (
    <AdvancedAutocomplete<Role>
      {...props}
      options={filter(roles, ({ id }) => !selectedRoles.has(id) || id === field.value)}
      value={roles.find(({ id }) => id === field.value)}
      getOptionInfo={(option: Role) => ({
        left: option.name,
        id: option.id,
      })}
      onAdd={
        !addRole
          ? undefined
          : async () => {
              const role = await addRole()
              setFieldValue(field.name, role.id)
            }
      }
      onChange={(option: Role) => form.setFieldValue(field.name, option ? (option as Role).id : null)}
      error={touched && error ? error : undefined}
    />
  )
}
